module.exports = __webpack_public_path__ + "img/willow.be5030ca.webp";